var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-card',{attrs:{"header-mod-class":"card__header_as_bar","use-header-shadow":true},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('div',{staticClass:"notification-text"},[_vm._v(_vm._s(_vm.textMessage))])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }